export const HEALTH_SLICE_NAME = "health"
